module.exports = __webpack_public_path__ + "img/dick-perez.c0c1ce2a.jpg";